import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonIcon } from '@ionic/react';
import './PaymentsNone.css';

export default function PaymentsUnknown() {
  const [t] = useTranslation('global');

  return (
    <>
      <p className="ion-text-center">
        <IonIcon
          className="payment-icon-none"
          src={'assets/icon/card-big.svg'}
        ></IonIcon>
      </p>

      <div className="payment-methods">
        <IonIcon slot="start" src={'assets/icon/master_card.svg'}></IonIcon>
        <IonIcon slot="start" src={'assets/icon/visa.svg'}></IonIcon>
        <IonIcon slot="start" src={'assets/icon/american_express.svg'}></IonIcon>
      </div>
    </>
  );
}
